import { UserCheck, X } from 'lucide-react';
import { db } from '../db/schema';
import { track } from '../lib/analytics';
import {
  clearImpersonation,
  getImpersonatedDisplayName,
  isImpersonating,
} from '../lib/impersonation';

/**
 * Sticky en haut de l'app dès qu'une session imperso est active. Le bouton
 * "Arrêter" wipe Dexie + recharge — on perd le cache offline mais c'est OK
 * en mode test (online uniquement).
 */
export function ImpersonationBanner() {
  if (!isImpersonating()) return null;
  const name = getImpersonatedDisplayName() ?? 'Utilisateur inconnu';

  return (
    <div className="bg-violet-600 text-white px-4 py-2 flex items-center justify-between gap-3 text-meta sticky top-0 z-50">
      <div className="flex items-center gap-2 min-w-0">
        <UserCheck className="h-3.5 w-3.5 shrink-0" />
        <span className="font-semibold truncate">
          Vous voyez l'app comme <span className="font-extrabold">{name}</span>
        </span>
      </div>
      <button
        type="button"
        onClick={() => stopImpersonation()}
        className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/15 hover:bg-white/25 font-bold text-micro shrink-0"
      >
        <X className="h-3 w-3" />
        Arrêter
      </button>
    </div>
  );
}

export async function stopImpersonation() {
  track('imperso_stopped', {});
  clearImpersonation();
  await wipeDexieAndReload();
}

async function wipeDexieAndReload() {
  // wipe() vide les tables dans une transaction synchrone — plus fiable que
  // delete() qui peut racer avec le reload (l'IDB request peut ne pas être
  // committé avant la navigation, laissant un cache stale après reload).
  await db.wipe();
  window.location.href = '/';
}
